import type { RemediationApplyMode, RemediationRoe } from "../../api/types.js";

const POSTURE_LABEL: Record<RemediationApplyMode, string> = {
  "view-only": "View only",
  branch: "Branch only",
  merge: "Auto-merge enabled",
};

export function RemediationRoePosture({
  roe,
  onRevoke,
  canRevoke = true,
}: {
  roe: RemediationRoe | null;
  onRevoke: () => void;
  canRevoke?: boolean | undefined;
}) {
  return (
    <div className="remediation-roe-posture">
      <span>{roe ? POSTURE_LABEL[roe.applyMode] : "View only (no authorization on file)"}</span>
      {roe && canRevoke ? (
        <button className="text-button" type="button" onClick={onRevoke}>
          Revoke
        </button>
      ) : null}
    </div>
  );
}
